'use client';

import type { GA4EventParams } from '../../types';

// データレイヤーにイベントをプッシュする共通ヘルパー関数
// GA4の推奨パラメータ名を考慮し、ページビュー関連の情報を自動追加
export function pushToDataLayer(eventName: string, params: GA4EventParams = {}) {
  if (typeof window === 'undefined') return;

  // window.dataLayer が存在しない場合は初期化
  // biome-ignore lint/suspicious/noExplicitAny: dataLayerはグローバルオブジェクト
  (window as any).dataLayer = (window as any).dataLayer || [];
  // biome-ignore lint/suspicious/noExplicitAny: dataLayerはグローバルオブジェクト
  const dataLayer = (window as any).dataLayer;

  // イベント発生時のページ情報を自動で取得
  const pageContextParams: GA4EventParams = {
    page_location: window.location.href,
    page_title: document.title,
  };

  // 最終的なパラメータオブジェクトを作成
  // pageContextParams を先に展開し、params で渡された値が優先されるようにする
  const finalParams: GA4EventParams = {
    ...pageContextParams,
    ...params,
  };

  dataLayer.push({
    event: eventName,
    ...finalParams,
  });
}
